<template>
    <div class="order_detial no-trans" v-loading="loading">
        <div class="order_titles">点评服务详情</div>
        <div class="order_derial_box1">
            <div class="order_type">
                <div class="type_item" v-for="(item, index) in type_list" :key="index" :class="{ tyle_ac: tyle_ac >= index }">
                    <div class="type_icons">
                        <div class="lefts">
                            <div class="borders" v-if="index != 0"></div>
                        </div>
                        <div class="consts">
                            <div class="icons">{{ index + 1 }}</div>
                        </div>
                        <div class="rigths">
                            <div class="borders" v-if="index != (type_list.length - 1)"></div>
                        </div>
                    </div>
                    <div class="type_title">{{ item.title }}</div>
                    <div class="type_time">{{ item.times }}</div>
                </div>
            </div>
            <div class="order_state">
                <div class="lefts">
                    订单号：{{ order_detial.order_sn||'' }}  <span @click="handle_cope">复制</span>
                </div>
                <div class="rights">
                    订单状态：
                    <span >
                        {{ status==10?'待点评':'' }}
                        {{ status==20?'已点评':'' }}
                        {{ status==1?'被取消':'' }}
                    </span>
                </div>
            </div>
        </div>
        <div class="order_derial_box2">
            <div class="title_flex">
                <div class="lefts">
                    <img src="../../../../assets/img/user_info/user_dp/icon1.png" alt="">
                    点评信息
                </div>
                <div class="rights">
                    收起
                    <img src="../../../../assets/img/user_info/user_dp/icon3.png" alt="">

                </div>
            </div>
            <div class="info_box1">
                <div class="info_flex">
                    <div class="info_text1">案由：</div>
                    <div class="info_text2">
                        {{ (order_detial.cateid_txt||{}).title }}
                        {{ (order_detial.cateid2_txt||{}).title ?'/':'' }}{{ (order_detial.cateid2_txt||{}).title }}
                        {{ (order_detial.cateid3_txt||{}).title?'/':'' }}{{ (order_detial.cateid3_txt||{}).title }}
                        
                        <!-- {{ minx_get_causeIds(`${order_detial}`)  }} -->
                    </div>
                </div>
                <div class="info_flex">
                    <div class="info_text1">纠纷发生地：</div>
                    <div class="info_text2">{{ order_detial.happen_province }}-{{ order_detial.happen_city }}-{{ order_detial.happen_area }}</div>
                </div>
                <div class="info_flex">
                    <div class="info_text1">委托人住所地：</div>
                    <div class="info_text2">{{ order_detial.province }}-{{ order_detial.city }}-{{ order_detial.area }}</div>
                </div>
                <div class="info_flex">
                    <div class="info_text1">描述：</div>
                </div>
                <div class="info_html">
                    {{  order_detial.desc }}
                </div>
                <div class="info_flex">
                    <div class="info_text1">提出审判异议：</div>
                </div>
                <div class="info_html">
                    {{  order_detial.trial_obj }}
                </div>
                <div class="info_order"></div>
                <div class="info_btns">
                    <div class="lefts">
                        <div class="btns1"><img src="../../../../assets/img/index/comments_case/flie_url.png" alt="">相关资料</div>
                        <div>
                            <div class="btns2" v-for="(item,index) in file_list" :key="index" @click="handle_file_up(item)">{{ item.name }}</div>
                        </div>
                    </div>
                    <!-- <div class="rights">
                        <div class="btns1">下载点评内容</div>
                    </div> -->
                </div>
                
            </div>
            <div class="title_flex"  v-if="order_list.length!=0">
                <div class="lefts">
                    <img src="../../../../assets/img/user_info/user_dp/icon2.png" alt="" @click="handle_dp">
                    点评信息
                </div>
            </div>
            <div class="info_box2">
                <div class="info_dp_no" v-if="status==10">
                    <div class="btns1"  @click="handle_add">立即点评</div>
                </div>
                <div class="info_dp_list" v-else>
                    <div class="list_item" v-for="(item,index) in order_list" :key="index" v-if="item.status==20">
                        <div class="lefts">
                            <div class="user_img">
                                <img src="@/assets/img/index/comments_case/user_img.png" alt="" v-if="!user_info.image">
                                <img :src="user_info.image" alt="" v-if="user_info.image">
                            </div>
                        </div>
                        <div class="rights">
                            <div class="user_flex">
                                <div class="flex_user">
                                    <div class="names">{{ user_info.name }}</div>
                                    <div class="times">点评于 {{ item.created_at }}</div>
                                </div>
                              
                            </div>
                            <div class="dp_info">
                                <div class="info_box" v-for="(items,indexs) in form_list" :key="indexs" v-if="items.show_num==order_detial.grade">
                                    <div class="info_title">{{ items.title }}</div>
                                    <div class="info_texts">
                                        {{ item[items.form_text] }}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            
          
            
        </div>
   
    </div>
</template>
<script>
import { mapState } from 'vuex'

 

export default {
    components: {
       

    },
    name: "homes",
    data() {
        return {
            loading: false,
            status:0,
            tyle_ac: 0,
            type_list: [
                {
                    title: '提交订单',
                    times: ''
                },
                {
                    title: '待点评',
                    times: ''
                },
                {
                    title: '已点评',
                    times: ''
                }
            ],
            order_detial:{},
            order_list:[],
            file_list:[],

            form_list:[
                {
                    show_num:'1',//
                    title:'查明事实',
                    out_show:true,//是否必填 是否显示*
                    form_text:'cmss',//提交的字段
                    form_val:'',//提交的值
                    placeholder_text:'请输入查明事实',
                },
                {
                    show_num:'1',//
                    title:'法院认定',
                    out_show:true,//是否必填 是否显示*
                    form_text:'fyrd',//提交的字段
                    form_val:'',//提交的值
                    placeholder_text:'请输入法院认定',
                },
                { 
                    show_num:'1',//
                    title:'法律适用',
                    out_show:true,//是否必填 是否显示*
                    form_text:'flsy',//提交的字段
                    form_val:'',//提交的值
                    placeholder_text:'请输入法律适用',
                },
                {
                    show_num:'1',//
                    title:' 法律判决',
                    out_show:true,//是否必填 是否显示*
                    form_text:'fypj',//提交的字段
                    form_val:'',//提交的值
                    placeholder_text:'请输入法律判决',
                },

                 {
                    show_num:'1',//
                    title:' 法律建议',
                    out_show:true,//是否必填 是否显示*
                    form_text:'fljy',//提交的字段
                    form_val:'',//提交的值
                    placeholder_text:'请输入法律建议',
                },
                {
                    show_num:'2',//
                    title:'法院调查',
                    out_show:true,//是否必填 是否显示*
                    form_text:'ftdc',//提交的字段
                    form_val:'',//提交的值
                    placeholder_text:'请输入法院调查',
                },
                {
                    show_num:'2',//
                    title:'证据质证',
                    out_show:true,//是否必填 是否显示*
                    form_text:'zjzz',//提交的字段
                    form_val:'',//提交的值
                    placeholder_text:'请输入证据质证',
                },
                {
                    show_num:'2',//
                    title:'法院辩论',
                    out_show:true,//是否必填 是否显示*
                    form_text:'fybl',//提交的字段
                    form_val:'',//提交的值
                    placeholder_text:'请输入法院辩论',
                },
                {
                    show_num:'2',//
                    title:'查明事实',
                    out_show:true,//是否必填 是否显示*
                    form_text:'cmss',//提交的字段
                    form_val:'',//提交的值
                    placeholder_text:'请输入查明事实',
                },
                {
                    show_num:'2',//
                    title:'法院认定',
                    out_show:true,//是否必填 是否显示*
                    form_text:'fyrd',//提交的字段
                    form_val:'',//提交的值
                    placeholder_text:'请输入法院认定',
                },
                {
                    show_num:'2',//
                    title:'法律适用',
                    out_show:true,//是否必填 是否显示*
                    form_text:'flsy',//提交的字段
                    form_val:'',//提交的值
                    placeholder_text:'请输入法律适用',
                },
                {
                    show_num:'2',//
                    title:'法律建议',
                    out_show:true,//是否必填 是否显示*
                    form_text:'fljy',//提交的字段
                    form_val:'',//提交的值
                    placeholder_text:'请输入法律建议',
                },


                {
                    show_num:'3',//
                    title:'法庭调查',
                    out_show:true,//是否必填 是否显示*
                    form_text:'ftdc',//提交的字段
                    form_val:'',//提交的值
                    placeholder_text:'请输入法庭调查',
                },
                {
                    show_num:'3',//
                    title:'证据质证',
                    out_show:true,//是否必填 是否显示*
                    form_text:'zjzz',//提交的字段
                    form_val:'',//提交的值
                    placeholder_text:'请输入证据质证',
                },
                {
                    show_num:'3',//
                    title:'庭审笔录',
                    out_show:true,//是否必填 是否显示*
                    form_text:'tsbl',//提交的字段
                    form_val:'',//提交的值
                    placeholder_text:'请输入庭审笔录',
                },
                {
                    show_num:'3',//
                    title:'法院辩论',
                    out_show:true,//是否必填 是否显示*
                    form_text:'fybl',//提交的字段
                    form_val:'',//提交的值
                    placeholder_text:'请输入法院辩论',
                },
                {
                    show_num:'3',//
                    title:'查明事实',
                    out_show:true,//是否必填 是否显示*
                    form_text:'cmss',//提交的字段
                    form_val:'',//提交的值
                    placeholder_text:'请输入查明事实',
                },
                {
                    show_num:'3',//
                    title:'法院认定',
                    out_show:true,//是否必填 是否显示*
                    form_text:'fyrd',//提交的字段
                    form_val:'',//提交的值
                    placeholder_text:'请输入法院认定',
                },
                {
                    show_num:'3',//
                    title:' 法律适用',
                    out_show:true,//是否必填 是否显示*
                    form_text:'flsy',//提交的字段
                    form_val:'',//提交的值
                    placeholder_text:'请输入法律适用',
                },
                {
                    show_num:'3',//
                    title:' 类案比较',
                    out_show:true,//是否必填 是否显示*
                    form_text:'labj',//提交的字段
                    form_val:'',//提交的值
                    placeholder_text:'请输入类案比较',
                },
                {
                    show_num:'3',//
                    title:'法官裁量空间',
                    out_show:true,//是否必填 是否显示*
                    form_text:'fgclkj',//提交的字段
                    form_val:'',//提交的值
                    placeholder_text:'请输入法官裁量空间',
                },
                {
                    show_num:'3',//
                    title:'法律建议',
                    out_show:true,//是否必填 是否显示*
                    form_text:'fljy',//提交的字段
                    form_val:'',//提交的值
                    placeholder_text:'请输入法律建议',
                },


                

                {
                    show_num:'4',//
                    title:'法庭调查',
                    out_show:true,//是否必填 是否显示*
                    form_text:'ftdc',//提交的字段
                    form_val:'',//提交的值
                    placeholder_text:'请输入法庭调查',
                },
                {
                    show_num:'4',//
                    title:'证据质证',
                    out_show:true,//是否必填 是否显示*
                    form_text:'zjzz',//提交的字段
                    form_val:'',//提交的值
                    placeholder_text:'请输入证据质证',
                },
                {
                    show_num:'4',//
                    title:'庭审笔录',
                    out_show:true,//是否必填 是否显示*
                    form_text:'tsbl',//提交的字段
                    form_val:'',//提交的值
                    placeholder_text:'请输入庭审笔录',
                },
                {
                    show_num:'4',//
                    title:'法院辩论',
                    out_show:true,//是否必填 是否显示*
                    form_text:'fybl',//提交的字段
                    form_val:'',//提交的值
                    placeholder_text:'请输入法法院辩论',
                },
                {
                    show_num:'4',//
                    title:'查明事实',
                    out_show:true,//是否必填 是否显示*
                    form_text:'cmss',//提交的字段
                    form_val:'',//提交的值
                    placeholder_text:'请输入查明事实',
                },
                {
                    show_num:'4',//
                    title:'法院认定',
                    out_show:true,//是否必填 是否显示*
                    form_text:'fyrd',//提交的字段
                    form_val:'',//提交的值
                    placeholder_text:'请输入法院认定',
                },
                {
                    show_num:'4',//
                    title:' 法律适用',
                    out_show:true,//是否必填 是否显示*
                    form_text:'flsy',//提交的字段
                    form_val:'',//提交的值
                    placeholder_text:'请输入法律适用',
                },
                {
                    show_num:'4',//
                    title:' 类案比较',
                    out_show:true,//是否必填 是否显示*
                    form_text:'labj',//提交的字段
                    form_val:'',//提交的值
                    placeholder_text:'请输入类案比较',
                },
                {
                    show_num:'4',//
                    title:'法官裁量空间',
                    out_show:true,//是否必填 是否显示*
                    form_text:'fgclkj',//提交的字段
                    form_val:'',//提交的值
                    placeholder_text:'请输入法官裁量空间',
                },
                {
                    show_num:'4',//
                    title:'法律建议',
                    out_show:true,//是否必填 是否显示*
                    form_text:'fljy',//提交的字段
                    form_val:'',//提交的值
                    placeholder_text:'请输入法律建议',
                },
            ],
            user_info:{},

        }
    },
    computed: {
        ...mapState(['vuex_user', 'vuex_unread_number'])
    },
    watch: {

    },
    created() {
        this.get_detial()
        this.get_user_info()
    },
    methods: {
        handle_cope(){
            navigator.clipboard.writeText(this.order_detial.order_sn).then(function() {
                alertSucc("复制成功！");
            }).catch(function(err) {
                alertErr("复制失败：" + err);
            });
        },
        get_user_info(){
            this.$api("getUserInfo", {
              
			}, "get").then((res) => {
                this.loading = false
                console.log('用户信息',res)
                if (res.code == 1) {
                   this.user_info=res.data
                } else {
                    alertErr(res.msg)
                }
            });
        },
        handle_dp(){
            this.$router.push({
                path:'/user_dpfw/user_dpfw_add',
                query:{
                    id:this.$route.query.id,
                    grade:item.grade,
                }
            })
        },
        handle_file_up(item){
            window.open(item.path)
        },
        get_detial(){
            this.loading=true
            this.$api("lawyerCaseCommentDetail", {
                id:this.$route.query.id
			}, "get").then((res) => {
                this.loading = false
                this.loading=false
                console.log('律师点评详情',res)
                if (res.code == 1) {
                    this.order_detial=res.data
                    this.order_list=[]
                    let status=0
                    if(res.data.lawyer_comment){
                        status=res.data.lawyer_comment[0].status
                        this.status=status
                        res.data.lawyer_comment.forEach((e)=>{
                            if(e.status==20){
                                this.order_list.push(e)
                            }
                        })
                    }
                    this.file_list=[]
                   this.type_list[0].times=res.data.created_at
                   if(status==10){
                    this.tyle_ac=1
                   }
                   if(status>=10){
                    this.type_list[1].times=res.data.lawyer_comment[0].created_at

                   }
                   if(status==20){
                    this.tyle_ac=2
                    this.type_list[2].times=res.data.updated_at

                   }


                    if(res.data.evidence_file){
                        let list=JSON.parse(res.data.evidence_file)
                        list.forEach((e)=>{
                            this.file_list.push(e)
                        })
                    }   
                    if(res.data.judgment){
                        let list=JSON.parse(res.data.judgment)
                        list.forEach((e)=>{
                            this.file_list.push(e)
                        })
                    }   
                    if(res.data.record_file){
                        let list=JSON.parse(res.data.record_file)
                        list.forEach((e)=>{
                            this.file_list.push(e)
                        })
                    }   
                } else {
                    alertErr(res.msg)
                }
            });
        },
        handle_add(){
            this.$router.push({
                path:'/user_dpfw/user_dpfw_add',
                query:{
                    id:this.$route.query.id,
                    grade:this.order_detial.lawyer_comment[0].comment_level
                }
            })
        },
        



    },

}
</script>
<style scoped lang="less">
.order_detial {
    .order_titles {
        width: 1196px;
        height: 56px;
        background: #FFFFFF;
        border-radius: 0px 0px 0px 0px;
        padding: 0 32px;
        font-family: Microsoft YaHei, Microsoft YaHei;
        font-weight: bold;
        font-size: 16px;
        color: #333333;
        line-height: 56px;
    }

    .order_derial_box1 {
        margin-top: 24px;
        padding: 72px 24px;
        background: #FFFFFF;
        .order_type {
            display: flex;
            // align-items: top;
            justify-content: center;
            .type_item {
                .type_icons {
                    display: flex;
                    align-items: top;
                    .lefts {
                        width: 148px;
                        height: 44px;
                        display: flex;
                        align-items: center;
                        .borders {
                            width: 148px;
                            height: 2px;
                            // background: #377CFD;
                            background: #F5F5F5;
                            border-radius: 0px 0px 0px 0px;
                        }
                    }
                    .consts {
                        .icons {
                            width: 44px;
                            height: 44px;
                            background: rgba(55, 124, 253, 0.06);
                            border-radius: 50%;
                            text-align: center;
                            line-height: 44px;
                            font-weight: 400;
                            font-size: 20px;
                            color: #999999;
                        }
                    }
                    .rigths {
                        width: 148px;
                        height: 44px;
                        display: flex;
                        align-items: center;
                        .borders {
                            width: 148px;
                            height: 2px;
                            // background: #377CFD;
                            background: #F5F5F5;
                            border-radius: 0px 0px 0px 0px;
                        }
                    }
                }

                .type_title {
                    text-align: center;
                    padding-top: 14px;
                    font-family: Microsoft YaHei, Microsoft YaHei;
                    font-weight: 400;
                    font-size: 14px;
                    color: #000000;
                }
                .type_time {
                    text-align: center;
                    font-family: Microsoft YaHei, Microsoft YaHei;
                    font-weight: 400;
                    font-size: 12px;
                    color: #808080;
                    padding-top: 8px;
                }
            }
            .tyle_ac {
                .type_icons {
                    .lefts {
                        .borders {
                            background: #377CFD;
                        }
                    }
                    .consts {
                        .icons {
                            background: #377CFD;
                            color: #FFFFFF;
                        }
                    }
                    .rigths {
                        .borders {
                            background: #377CFD;
                        }
                    }
                }
                .type_title {}

                .type_time {}
            }
        }
        .order_state{
            padding-top: 82px;
            display: flex;
            align-items: center;
            justify-content: space-evenly;
            .lefts{
                font-family: Microsoft YaHei, Microsoft YaHei;
                font-weight: 400;
                font-size: 14px;
                color: #55575B;
                span{
                    color: #007BFF;
                    cursor: pointer;
                    margin-left: 10px;
                }
            }
            .rights{
                font-family: Microsoft YaHei, Microsoft YaHei;
                font-weight: 400;
                font-size: 14px;
                color: #666666;
                span{
                    font-size: 20px;
                    color: #409EFF;
                }
            }
        }
    }
    .order_derial_box2{
        margin-top: 24px;
        background: #FFFFFF;
        padding: 32px;
        .title_flex{
            display: flex;
            align-items: center;
            justify-content: space-between;
            padding-bottom: 13px;
            border-bottom:1px solid #CCCCCC ;
            .lefts{
                font-family: Microsoft YaHei, Microsoft YaHei;
                font-weight: bold;
                font-size: 16px;
                color: #333333;
                display: flex;
                align-items: center;
                img{
                    width: 30px;
                    margin-right: 9px;
                }
            }
            .rights{
                font-family: Microsoft YaHei, Microsoft YaHei;
                font-weight: 400;
                font-size: 14px;
                color: #377CFD;
                cursor: pointer;
                display: flex;
                align-items: center;
                img{
                    width: 10px;
                    height: 10px;
                    margin-left: 8px;
                }
            }
        }
        .info_box1{
            padding-top: 24px;
            .info_flex{
                display: flex;
                align-items: center;
                margin-bottom: 16px;
                .info_text1{
                    width: 110px;
                    font-weight: 400;
                    font-size: 14px;
                    color: #333333;
                }
                .info_text2{
                    margin-left: 10px;
                    font-weight: 400;
                    font-size: 14px;
                    color: #333333;

                }
            }
            .info_html{
                font-weight: 400;
                font-size: 14px;
                color: #666666;
                padding-bottom: 45px;
            }
            .info_order{
                border-bottom: 3px dashed  #B9B9B9;
            }
            .info_btns{
                padding-top: 35px;
                display: flex;
                align-items: center;
                justify-content: space-between;
                padding-bottom: 110px;
                .lefts{
                    display: flex;
                    .btns1{
                        display: flex;
                        // align-items: center;
                        cursor: pointer;
                        font-weight: 400;
                        font-size: 14px;
                        color: #666666;
                        margin-right: 60px;
                        img{
                            // width: 16px;
                            height: 16px;
                            // height: auto;
                            margin-right: 10px;
                        }
                    }
                    .btns2{
                        font-family: Microsoft YaHei, Microsoft YaHei;
                        font-weight: 400;
                        font-size: 14px;
                        color: #333333;
                        cursor: pointer;
                        margin-bottom: 15px;
                    }

                }
                .rights{
                    display: flex;
                    .btns1{
                        width: 121px;
                        height: 32px;
                        background: #377CFD;
                        border-radius: 4px 4px 4px 4px;
                        text-align: center;               
                        line-height: 32px;
                        cursor: pointer;
                        font-family: Microsoft YaHei, Microsoft YaHei;
                        font-weight: 400;
                        font-size: 14px;
                        color: #FFFFFF;


                    }
                }
            }
        }
        .info_box2{
            .info_dp_no{
              display: flex;
              align-items: center;
              justify-content: center;
              .btns1{
                width: 104px;
                height: 32px;
                background: #377CFD;
                border-radius: 4px 4px 4px 4px;
                text-align: center;
                line-height: 32px;
                font-family: Microsoft YaHei, Microsoft YaHei;
                font-weight: 400;
                font-size: 14px;
                color: #FFFFFF;
                cursor: pointer;
              }
            }
            .info_dp_list{
                .list_item{
                    display: flex;
                    width: 1132px;
                    background: #FFFFFF;
                    border-radius: 4px 4px 4px 4px;
                    border: 1px solid #E8E8E8;
                    display: flex;
                    padding: 32px;
                    margin-bottom: 20px;
                    .lefts{
                        width: 40px;
                        height: 40px;

                        flex-shrink: 0;
                        .user_img{
                            img{
                                width: 40px;
                                height: 40px;
                            }
                        }
                    }
                    .rights{
                        padding-left: 16px;
                        flex: 1;
                        .user_flex{
                            display: flex;
                            align-items: center;
                            justify-content: space-between;
                            padding-bottom: 23px;
                            border-bottom: 1px dashed #DBDBDB;
                            .flex_user{
                                .names{
                                    font-family: Microsoft YaHei, Microsoft YaHei;
                                    font-weight: 400;
                                    font-size: 14px;
                                    color: #333333;
                                }
                                .times{
                                    margin-top: 5px;
                                    font-family: Microsoft YaHei, Microsoft YaHei;
                                    font-weight: 400;
                                    font-size: 12px;
                                    color: #666666;

                                }
                            }
                            .felx_btns{
                                .btns{
                                    width: 104px;
                                    height: 32px;
                                    background: #377CFD;
                                    border-radius: 4px 4px 4px 4px;
                                    text-align: center;
                                    line-height: 32px;
                                    font-family: Microsoft YaHei, Microsoft YaHei;
                                    font-weight: 400;
                                    font-size: 14px;
                                    color: #FFFFFF;
                                    cursor: pointer;
                                }
                            }
                        }
                        .dp_info{
                            padding-top: 24px;
                            .info_box{
                                margin-bottom: 15px;
                                .info_title{
                                    font-family: Microsoft YaHei, Microsoft YaHei;
                                    font-weight: bold;
                                    font-size: 16px;
                                    color: #333333;
                                }
                                .info_texts{
                                    padding-top: 15px;
                                    font-family: Microsoft YaHei, Microsoft YaHei;
                                    font-weight: 400;
                                    font-size: 14px;
                                    color: #666666;
                                }
                            }
                        }
                    }
                }
            }
        }
      
    }
    
}
</style>
<style scoped lang="less">
@media (max-width: 1024px) {
    .order_detial.no-trans {
        max-width: 100%;
        min-width: 0;
        font-size: 14px;
        line-height: 1.6;
    }
    .order_detial.no-trans .order_titles {
        max-width: 100%;
        min-width: 0;
        width: 100%;
        height: 56px;
        border-radius: 0px 0px 0px 0px;
        padding: 0 16px;
        font-size: 16px;
        line-height: 1.6;
    }
    .order_detial.no-trans .order_derial_box1 {
        margin-top: 16px;
        padding: 16px 16px;
    }
    .order_detial.no-trans .order_derial_box1 .order_type {
        flex-wrap: wrap;
        min-width: 0;
        gap: 8px;
    }
    .order_detial.no-trans .order_derial_box1 .order_type .type_item .type_icons {
        flex-wrap: wrap;
        min-width: 0;
        gap: 8px;
    }
    .order_detial.no-trans .order_derial_box1 .order_type .type_item .type_icons .lefts {
        width: 148px;
        height: auto;
        flex-wrap: wrap;
        min-width: 0;
        gap: 8px;
        min-height: 44px;
    }
    .order_detial.no-trans .order_derial_box1 .order_type .type_item .type_icons .lefts .borders {
        width: 148px;
        height: 2px;
        border-radius: 0px 0px 0px 0px;
    }
    .order_detial.no-trans .order_derial_box1 .order_type .type_item .type_icons .consts .icons {
        width: 44px;
        height: 44px;
        border-radius: 50%;
        line-height: 44px;
        font-size: 20px;
    }
    .order_detial.no-trans .order_derial_box1 .order_type .type_item .type_icons .rigths {
        width: 148px;
        height: auto;
        flex-wrap: wrap;
        min-width: 0;
        gap: 8px;
        min-height: 44px;
    }
    .order_detial.no-trans .order_derial_box1 .order_type .type_item .type_icons .rigths .borders {
        width: 148px;
        height: 2px;
        border-radius: 0px 0px 0px 0px;
    }
    .order_detial.no-trans .order_derial_box1 .order_type .type_item .type_title {
        padding-top: 14px;
        font-size: 14px;
    }
    .order_detial.no-trans .order_derial_box1 .order_type .type_item .type_time {
        font-size: 14px;
        padding-top: 8px;
    }
    .order_detial.no-trans .order_derial_box1 .order_state {
        padding-top: 16px;
        flex-wrap: wrap;
        min-width: 0;
        gap: 8px;
    }
    .order_detial.no-trans .order_derial_box1 .order_state .lefts {
        font-size: 14px;
    }
    .order_detial.no-trans .order_derial_box1 .order_state .lefts span {
        margin-left: 10px;
    }
    .order_detial.no-trans .order_derial_box1 .order_state .rights {
        font-size: 14px;
    }
    .order_detial.no-trans .order_derial_box1 .order_state .rights span {
        font-size: 20px;
    }
    .order_detial.no-trans .order_derial_box2 {
        margin-top: 16px;
        padding: 16px;
    }
    .order_detial.no-trans .order_derial_box2 .title_flex {
        flex-wrap: wrap;
        min-width: 0;
        gap: 8px;
        padding-bottom: 13px;
    }
    .order_detial.no-trans .order_derial_box2 .title_flex .lefts {
        font-size: 16px;
        flex-wrap: wrap;
        min-width: 0;
        gap: 8px;
    }
    .order_detial.no-trans .order_derial_box2 .title_flex .lefts img {
        width: 30px;
        margin-right: 9px;
    }
    .order_detial.no-trans .order_derial_box2 .title_flex .rights {
        font-size: 14px;
        flex-wrap: wrap;
        min-width: 0;
        gap: 8px;
    }
    .order_detial.no-trans .order_derial_box2 .title_flex .rights img {
        width: 10px;
        height: 10px;
        margin-left: 8px;
    }
    .order_detial.no-trans .order_derial_box2 .info_box1 {
        padding-top: 16px;
    }
    .order_detial.no-trans .order_derial_box2 .info_box1 .info_flex {
        flex-wrap: wrap;
        min-width: 0;
        gap: 8px;
        margin-bottom: 16px;
    }
    .order_detial.no-trans .order_derial_box2 .info_box1 .info_flex .info_text1 {
        width: 110px;
        font-size: 14px;
    }
    .order_detial.no-trans .order_derial_box2 .info_box1 .info_flex .info_text2 {
        margin-left: 10px;
        font-size: 14px;
    }
    .order_detial.no-trans .order_derial_box2 .info_box1 .info_html {
        font-size: 14px;
        padding-bottom: 16px;
    }
    .order_detial.no-trans .order_derial_box2 .info_box1 .info_btns {
        padding-top: 16px;
        flex-wrap: wrap;
        min-width: 0;
        gap: 8px;
        padding-bottom: 16px;
    }
    .order_detial.no-trans .order_derial_box2 .info_box1 .info_btns .lefts {
        flex-wrap: wrap;
        min-width: 0;
        gap: 8px;
    }
    .order_detial.no-trans .order_derial_box2 .info_box1 .info_btns .lefts .btns1 {
        flex-wrap: wrap;
        min-width: 0;
        gap: 8px;
        font-size: 14px;
        margin-right: 16px;
        min-height: 44px;
        height: auto;
        line-height: 1.6;
        padding-top: 12px;
        padding-bottom: 12px;
    }
    .order_detial.no-trans .order_derial_box2 .info_box1 .info_btns .lefts .btns1 img {
        height: 16px;
        margin-right: 10px;
    }
    .order_detial.no-trans .order_derial_box2 .info_box1 .info_btns .lefts .btns2 {
        font-size: 14px;
        margin-bottom: 15px;
        min-height: 44px;
        height: auto;
        line-height: 1.6;
        padding-top: 12px;
        padding-bottom: 12px;
    }
    .order_detial.no-trans .order_derial_box2 .info_box1 .info_btns .rights {
        flex-wrap: wrap;
        min-width: 0;
        gap: 8px;
    }
    .order_detial.no-trans .order_derial_box2 .info_box1 .info_btns .rights .btns1 {
        width: 121px;
        height: auto;
        border-radius: 4px 4px 4px 4px;
        line-height: 1.6;
        font-size: 14px;
        min-height: 44px;
        padding-top: 12px;
        padding-bottom: 12px;
    }
    .order_detial.no-trans .order_derial_box2 .info_box2 .info_dp_no {
        flex-wrap: wrap;
        min-width: 0;
        gap: 8px;
    }
    .order_detial.no-trans .order_derial_box2 .info_box2 .info_dp_no .btns1 {
        width: 104px;
        height: auto;
        border-radius: 4px 4px 4px 4px;
        line-height: 1.6;
        font-size: 14px;
        min-height: 44px;
        padding-top: 12px;
        padding-bottom: 12px;
    }
    .order_detial.no-trans .order_derial_box2 .info_box2 .info_dp_list .list_item {
        max-width: 100%;
        min-width: 0;
        width: 100%;
        border-radius: 4px 4px 4px 4px;
        flex-wrap: wrap;
        gap: 8px;
        padding: 16px;
        margin-bottom: 16px;
    }
    .order_detial.no-trans .order_derial_box2 .info_box2 .info_dp_list .list_item .lefts {
        width: 40px;
        height: 40px;
    }
    .order_detial.no-trans .order_derial_box2 .info_box2 .info_dp_list .list_item .lefts .user_img img {
        width: 40px;
        height: 40px;
    }
    .order_detial.no-trans .order_derial_box2 .info_box2 .info_dp_list .list_item .rights {
        padding-left: 16px;
    }
    .order_detial.no-trans .order_derial_box2 .info_box2 .info_dp_list .list_item .rights .user_flex {
        flex-wrap: wrap;
        min-width: 0;
        gap: 8px;
        padding-bottom: 16px;
    }
    .order_detial.no-trans .order_derial_box2 .info_box2 .info_dp_list .list_item .rights .user_flex .flex_user .names {
        font-size: 14px;
    }
    .order_detial.no-trans .order_derial_box2 .info_box2 .info_dp_list .list_item .rights .user_flex .flex_user .times {
        margin-top: 5px;
        font-size: 14px;
    }
    .order_detial.no-trans .order_derial_box2 .info_box2 .info_dp_list .list_item .rights .user_flex .felx_btns .btns {
        width: 104px;
        height: auto;
        border-radius: 4px 4px 4px 4px;
        line-height: 1.6;
        font-size: 14px;
        min-height: 44px;
        padding-top: 12px;
        padding-bottom: 12px;
    }
    .order_detial.no-trans .order_derial_box2 .info_box2 .info_dp_list .list_item .rights .dp_info {
        padding-top: 16px;
    }
    .order_detial.no-trans .order_derial_box2 .info_box2 .info_dp_list .list_item .rights .dp_info .info_box {
        margin-bottom: 15px;
    }
    .order_detial.no-trans .order_derial_box2 .info_box2 .info_dp_list .list_item .rights .dp_info .info_box .info_title {
        font-size: 16px;
    }
    .order_detial.no-trans .order_derial_box2 .info_box2 .info_dp_list .list_item .rights .dp_info .info_box .info_texts {
        padding-top: 15px;
        font-size: 14px;
    }
}
</style>
